import React from 'react';
import { Modal, Button } from '@mui/material';

const ConfirmationModal = ({ open, onClose, onConfirm, message }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal"
      aria-describedby="confirmation-message"
    >
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', padding: '20px', borderRadius: '5px' }}>
        <p id="confirmation-message">{message}</p>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button variant="contained" color="primary" onClick={onConfirm} style={{ marginRight: '10px' }}>Yes</Button>
          <Button variant="contained" color="primary" onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
